'use strict';

exports.__esModule = true;
exports['default'] = renameProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function renameProps(newNames) {
  return function (Target) {
    (0, _validators.validateClass)(Target, 'renameProps');

    return function (props) {
      var newProps = Object.assign({}, props);
      var names = Object.keys(newNames);
      Object.keys(newProps).forEach(function (key) {
        var nameIndex = names.indexOf(key);
        if (names && key && nameIndex !== -1) {
          newProps[newNames[names[nameIndex]]] = newProps[key];
          delete newProps[key];
        }
      });
      return _react2['default'].createElement(Target, newProps);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/renameProps.js
// module id = 555
// module chunks = 1